export const BRAND = {
  name: "Wellpec",
  tagline: "Soluções em equipamentos para a indústria de óleo, gás e energia",
  email: "vendas@wellpec.com.br",
  phone: "(071) 2132-2687",
  whatsapp: "557121322687",
  whatsappDisplay: "(071) 2132-2687",
  address: "Rua Honor Gregorio Santos, 36 — Aracaju/SE",
};

export const WHATSAPP_URL = (msg = "Olá! Gostaria de solicitar um orçamento.") =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(msg)}`;

export const PRODUCT_LINES = [
  {
    slug: "perfuracao-workover",
    title: "Perfuração & Workover",
    short: "Equipamentos e ferramentas para intervenções seguras e operações contínuas de poço.",
    bullets: ["Chaves hidráulicas", "Tubos e ferramentas de perfuração", "Equipamentos de registro", "Suporte à especificação"],
    image: "/images/products/chave-hidraulica.png",
  },
  {
    slug: "spare-parts",
    title: "BOP & Spare Parts",
    short: "Peças de reposição para BOPs, válvulas, bombas e equipamentos críticos.",
    bullets: ["Reposição para BOP", "Kits e sobressalentes", "Componentes de vedação", "Rastreabilidade documental"],
    image: "/images/products/bop-spare-parts.png",
  },
  {
    slug: "valvulas",
    title: "Válvulas Industriais",
    short: "Soluções para controle de fluxo, segurança e confiabilidade operacional.",
    bullets: ["Válvulas de processo", "Válvulas de segurança", "Atuadores e acessórios", "Aplicações onshore e offshore"],
    image: "/images/products/valvula-industrial.png",
  },
  {
    slug: "consumiveis",
    title: "Consumíveis & Componentes",
    short: "Insumos críticos para perfuração, completação, produção e manutenção.",
    bullets: ["Telas de peneira", "Mangueiras e coflexip", "Mud pump parts", "Fornecimento recorrente"],
    image: "/images/products/tela-peneira.png",
  },
  {
    slug: "ferramentas-hidraulicas",
    title: "Ferramentas Hidráulicas",
    short: "Chaves de torque e tensionadores hidráulicos para aperto e desaperto controlado em operações críticas.",
    bullets: ["Chaves de Torque", "Tensionador Hidráulico", "Acionamento hexagonal e quadrado", "Suporte à especificação"],
    image: "/images/products/chave-torque-hidraulica.jpg",
  },
  {
    slug: "containers-solucoes-modulares",
    title: "Containers e Soluções Modulares para Canteiro",
    short: "Containers certificados e soluções modulares para oficinas, equipamentos e estruturas de apoio em canteiros industriais.",
    bullets: ["Containers ISO e especiais", "Soluções offshore DNV 2.7-1", "Módulos para oficinas e equipamentos", "Configurações e acessórios sob medida"],
    image: "/images/products/boxwell-containers-solucoes-modulares.webp",
  },
];

export const CATALOGS = [
  {
    slug: "catalogo-geral",
    title: "Catálogo Wellpec — Equipamentos de Campo",
    tag: "Catálogo geral",
    desc: "Portfólio completo de equipamentos, spare parts e materiais consumíveis para operações de óleo, gás e energia.",
    file: "/catalog/catalogo-wellpec-equipamentos-de-campo.pdf",
  },
  {
    slug: "catalogo-boxwell",
    title: "Catálogo Boxwell — Containers e Soluções Modulares para Canteiro",
    tag: "Catálogo Boxwell",
    desc: "Containers ISO, offshore e especiais, soluções para equipamentos e acessórios para canteiros e operações industriais.",
    file: "/catalog/catalogo-boxwell-wellpec-containers-solucoes-modulares.pdf",
  },
  {
    slug: "ficha-tecnica-thl",
    title: "Chave de Torque Hidráulica — Série THL (Acionamento Hexagonal)",
    tag: "Ficha técnica",
    desc: "Cinco modelos com faixas de torque de aproximadamente 200 a 35.000 ft-lb, projetados para espaços restritos.",
    file: "/catalog/ficha-tecnica-thl-chave-torque-hexagonal.pdf",
  },
  {
    slug: "ficha-tecnica-tsl",
    title: "Chave de Torque Hidráulica — Série TSL (Acionamento Quadrado)",
    tag: "Ficha técnica",
    desc: "Torque disponível até 50.000 ft-lb, pressão máxima de operação de 10.000 psi (700 bar) e precisão de ±3%.",
    file: "/catalog/ficha-tecnica-tsl-chave-torque-quadrada.pdf",
  },
  {
    slug: "ficha-tecnica-btl",
    title: "Tensionador Hidráulico de Parafusos — Série BTL (Aplicação Superior)",
    tag: "Ficha técnica",
    desc: "Solução hidráulica para tensionamento controlado de parafusos, com referências dimensionais por modelo.",
    file: "/catalog/ficha-tecnica-btl-tensionador-hidraulico.pdf",
  },
  {
    slug: "ficha-tecnica-slt",
    title: "Tensionador Hidráulico de Parafusos — Série SLT (Retorno por Mola)",
    tag: "Ficha técnica",
    desc: "Pressão de trabalho de 1.500 bar, kit de vedação com compensação de desalinhamento e retorno por mola.",
    file: "/catalog/ficha-tecnica-slt-tensionador-hidraulico.pdf",
  },
];

export const CLIENTS = [
  "Petrobras",
  "Eneva",
  "Conterp",
  "Imetame",
  "Petroreconcavo",
  "Axia",
];

export const DELIVERIES = [
  {
    title: "Equipamentos preparados para fornecimento",
    desc: "Registro real de equipamentos inspecionados, protegidos e preparados para expedição.",
    image: "/images/proof/equipamento-wellpec.jpeg",
    tag: "Entrega real",
  },
  {
    title: "Tubulares e componentes de perfuração",
    desc: "Atendimento de demandas industriais com volume, padronização e controle dimensional.",
    image: "/images/proof/tubos-perfuracao.jpeg",
    tag: "Supply industrial",
  },
  {
    title: "Sistemas para operações críticas",
    desc: "Fornecimento de conjuntos técnicos com identificação e documentação aplicável.",
    image: "/images/proof/sistema-controle.jpeg",
    tag: "Rastreabilidade",
  },
];

export const SEGMENTS = [
  { title: "Óleo & Gás", desc: "Upstream, midstream, onshore e offshore." },
  { title: "Energia", desc: "Geração, transmissão e infraestrutura crítica." },
  { title: "Supply Chain Industrial", desc: "Abastecimento recorrente e sob demanda." },
  { title: "Mineração", desc: "Exploração, desenvolvimento mineral e operação de lavra." },
];

export const DIFFERENTIATORS = [
  { title: "Atendimento especializado", desc: "Time técnico-comercial com experiência em campo e compras industriais.", icon: "Headphones" },
  { title: "Agilidade comercial", desc: "Processo de cotação objetivo, com comunicação direta sobre escopo e prazo.", icon: "Zap" },
  { title: "Qualidade e rastreabilidade", desc: "Produtos com documentação e certificações aplicáveis ao fornecimento.", icon: "ShieldCheck" },
  { title: "Suporte técnico", desc: "Apoio para especificar corretamente e reduzir incompatibilidades e retrabalho.", icon: "Wrench" },
  { title: "Experiência setorial", desc: "Conhecimento de óleo e gás e operações industriais de missão crítica.", icon: "Compass" },
  { title: "Eficiência operacional", desc: "Foco em disponibilidade de ativos, redução de downtime e previsibilidade.", icon: "TrendingUp" },
];

export const PROOF = [
  { value: "15+", label: "anos de experiência setorial" },
  { value: "300+", label: "itens no portfólio" },
  { value: "24h", label: "meta de retorno comercial" },
  { value: "BR + LATAM", label: "alcance de atendimento" },
];
